import daisy from 'daisy-chart/src/layouts'

import fire from './examples/data/fire.json';
import consumer from './examples/data/consumer_price.json';
import fire2 from './examples/data/fire2.json';
import weather from './examples/data/weather.json';
import big_city from './examples/data/big_city.json';
import big_city2 from './examples/data/big_city2.json';

console.log(daisy);

daisy.bar().data(fire)
    .container('#daisy-example-01')
    .dimensions(['년도'])
    .measures([{field: '전기적요인', op: 'sum'}, {field: '기계적요인', op: 'sum'}])
    .axis('x').axis('y')
    .render();

daisy.line().data(consumer)
    .container('#daisy-example-02')
    .dimensions(['년도','종류'])
    .measures([{field: '지수', op: 'sum'}])
    .multiTooltip(true)
    .point(true)
    .curve('curved')
    .axis('x').axis('y')
    .render();
      
daisy.pie().data(fire2)
    .container('#daisy-example-03')
    .width(640).height(550)
    .dimensions(['요인'])
    .measures(['수치'])
    .size([20, 200])
    .render();

daisy.scatter().data(weather)
    .container('#daisy-example-04')
    .width(640).height(540)
    .dimension('날짜')
    .measures(['최고기온(℃)', '최저기온(℃)'])
    .axis('x').axis('y')
    .render();

daisy.treemap().data(big_city2)
    .container('#daisy-example-05')
    .width(640).height(540)
    .dimensions(['대륙', '국가'])
    .label(true)
    .legend(true)
    .size([400, 400])
    .render();

daisy.xyHeatmap().data(big_city)
    .container('#daisy-example-06')
    .width(640).height(540)
    .dimensions(['대륙', '국가'])
    .axis('x').axis('y')
    .legend(true)
    .render();


// WEBPACK FOOTER //
// ./js/carousel.js